<template>
<v-layout style="padding-top:49px;" row fill-height>
  <div class="loading" v-if="loading">
    <v-layout align-center justify-center row fill-height>
        <v-progress-circular :size="25" :width="3" color="grey" indeterminate >
          </v-progress-circular>
        </v-layout>
  </div>
  <!-- <v-snackbar  v-model="errorLoading" color="error" :timeout="timeout" top="top">
    {{errorMsg}}
  </v-snackbar>-->
  <!-- <v-snackbar  v-model="error" color="error" :timeout="timeout" top="top">
    Disconnecting
  </v-snackbar> -->
  <PMHeader  v-if="true" :hideTitle="false" :moteUdid="moteNow"/>
  <pmdialog :data="dialogData" :dialog="dialogState" @closeDialog="dialogState = $event"/>
  <v-container >
    <v-layout align-end>
      <v-col cols="3" style="padding:0px" v-for="item in typeList" :key="item.type">
        <v-btn elevation="0" class="custom-disable" block :disabled="item.isNow"
             :style="{'background-color':item.isNow ? 'White !important':item.color}"
             @click="changeType(item.type)">
          {{item.name}}
        </v-btn>
      </v-col>
    </v-layout>
    <v-layout justify-center align-center v-if="!typeList.find(item=>item.type==='keyBot').isNow">
      <v-col cols="4">
        <v-row justify="center" align="center">
          <h2>App List</h2>
        </v-row>
      </v-col>
      <v-col cols="5">
        <div v-if="isShowErrorMsg">
          <!-- <v-row v-for="(item,index) in dialogData.data" :key="index">
            <h4>{{index}}:{{item}}</h4>
          </v-row>-->
          <h4 v-if="!mmsReady" style="color:gold">Error:{{dialogData.data.WebMMS_ErrMsg}}</h4>
          <h4 v-else-if="!isMoteConnected" style="color:orangered">Error:{{dialogData.data.Device_ErrMsg}}</h4>
        </div>
      </v-col>
      <v-col cols="3">
        <v-layout align-center justify-center>
          <v-btn elevation="2" icon small v-indicator @click="toggle()" class="ma-4" :class="{'event_status_connect' : isMoteConnected, 'event_mote_disconnect': !isMoteConnected,'event_webmms_disconnect':!mmsReady, 'event_mote_empty':isNoMoteUdid }"/>
          <!-- <v-btn elevation="2" icon @click="reloadPage()" class="ma-2">
            <v-icon>
              loop
            </v-icon>
        </v-btn>-->
        </v-layout>
      </v-col>
    </v-layout>
    <div  id="snap" style="height:70vh" v-if="typeList.find(item=>item.type==='snap').isNow">
      <v-layout justify-center>
        <v-card outlined class="event_card">
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col v-for="item in snapProperty" :key="item.value" :cols="columnSize['snap']" >
                <v-layout justify-center align-center>
                  <div style="text-align:center;">{{item.text}}</div>
                </v-layout>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-layout>
      <div class="scroller">
        <v-layout justify-center v-for="item in snap" :key="item.name">
          <v-card outlined class="event_card" @click="goToActionPage(item,'snap')" :disabled="!isMoteConnected">
            <v-card-text>
              <v-row align="center" justify="center">
                <v-col :cols="columnSize['snap']" >
                  <v-layout align-center justify-center>
                    <v-img :src="item.src" :max-width="columnSize['snap']*15"/>
                  </v-layout>
                  <v-layout align-center justify-center>
                    <v-card-text  style="text-align:center;">{{item.name}}</v-card-text>
                  </v-layout>
                </v-col>
                <v-col :cols="columnSize['snap']">
                  <v-layout justify-center align-center>
                    <v-icon v-if="item.autostart" color="green" large>check_circle</v-icon>
                    <v-icon v-if="!item.autostart" color="red" large>close</v-icon>
                  </v-layout>
                </v-col>
                <v-col :cols="columnSize['snap']">
                  <v-layout justify-center align-center>
                    <v-icon v-if="item.installed" color="green" large>check_circle</v-icon>
                    <v-icon v-if="!item.installed" color="red" large>close</v-icon>
                  </v-layout>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-layout>
      </div>
    </div>
    <div id='webApp' style="height:70vh" v-if="typeList.find(item=>item.type==='webApp').isNow">
      <div class="imformChromium" v-if="!isChromium&&!isChromium_browser&&isMoteConnected">
        <v-layout align-center justify-center fill-height>
          <div>Need to install Chromium.Press <v-btn small text style="padding:0;color:orange" @click="installChromium">here</v-btn> to install</div>
        </v-layout>
      </div>
      <v-layout justify-center>
        <v-card outlined class="event_card">
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col v-for="item in webAppProperty" :key="item.value" :cols="columnSize['webApp']" >
                <v-layout justify-center align-center>
                  <div>{{item.text}}</div>
                </v-layout>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-layout>
      <div class="scroller">
        <v-layout justify-center v-for="item in webApp" :key="item.name">
          <v-card outlined class="event_card" @click="goToActionPage(item,'webApp')" :disabled="!isChromium&&!isChromium_browser">
            <v-card-text>
              <v-row align="center" justify="center">
                <v-col :cols="columnSize['webApp']" >
                  <v-layout align-center justify-center>
                    <v-img :src="item.src" :max-width="columnSize['webApp']*15"/>
                  </v-layout>
                  <v-layout align-center justify-center>
                    <v-card-text style="text-align:center;">{{item.name}}</v-card-text>
                  </v-layout>
                </v-col>
                <v-col :cols="columnSize['webApp']">
                  <v-layout justify-center align-center>
                    <v-card-text style="text-align:center;">{{item.url}}</v-card-text>
                  </v-layout>
                </v-col>
                <v-col :cols="columnSize['webApp']">
                  <v-layout justify-center align-center>
                    <v-icon v-if="item.autostart" color="green" large>check_circle</v-icon>
                    <v-icon v-if="!item.autostart" color="red" large>close</v-icon>
                  </v-layout>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-layout>
      </div>
    </div>
    <div id='keyBot' style="height:70vh" v-if="typeList.find(item=>item.type==='keyBot').isNow">
      <PMKeybot class="my-2"  :mms="mms" :mmsReady="mmsReady" :moteDDN="moteDDN"/>
    </div>
  </v-container>
</v-layout>
</template>
<script>
import {
  set as setCookie,
  get as getCookie,
  remove as removeCookie
} from "es-cookie";
import webmms from "webmms-client";
import conf from "@/config/config";
import clock from "@/components/page-components/Clock.vue";
import pmdialog from "@/components/page-components/ProgramManager/PMDialog";
import snap from "@/assets/json/snap";
import webApp from "@/assets/json/webApp";
import PMHeader from "@/components/page-components/ProgramManager/Header.vue";
import PMKeybot from "@/components/page-components/ProgramManager/PMKeybot.vue";

export default {
  name: 'pmStatus',
  components:{
      clock,
      pmdialog,
      PMHeader,
      PMKeybot
  },
  data() {
    return {
        params: null,
        error: true,
        errorLoading: false,
        errorMsg: "",
        mmsReady: false,
        mms: null,
        eiInfo: {
          eiName: "",
          eiTag: "",
          ddn: ""
        },
        webmmsOptions: {
          EiToken: "",
          SToken: "",
          UToken: ""
        },
        infoSnack: false,
        infoSnakText: 'Sent successful',
        loading: false,
        isLoading: false,
        urt :{
          ddn: '',
          topic: '',
          func: '',
          payload: ''
        },
        eventList: [],
        timeout: 3000,
        typeList:[
          {type:'snap',name:'Snap App',color:'#f5f5f5', isNow:true},
          {type:'webApp',name:'Web App',color:'#f5f5f5' ,isNow:false},
          {type:'keyBot',name:'Key Bot',color:'#f5f5f5',isNow:false}
        ],
        snapProperty:snap.property,
        snap:snap.list,
        webAppProperty:webApp.property,
        webApp:webApp.list,
        snapInstallList:[],
        appAutoStartList:[],
        taskNow:'',
        taskList:[
          {name:'installed',value:'getInstalledSnapList'},
          {name:'autoStart',value:'getAutoStartSnapList'},
          {name:'checkBrowser',value:'checkChromiumInstalled'}
        ],
        moteNow:'',
        moteDDN:'',
        isNoMoteUdid:true,
        isMoteConnected:false,
        isShowErrorMsg:false,
        isChromium:false,
        isChromium_browser:false,
        dialogData:{
          time:'',
          data:{
            DeviceUdid:'',
            WebMMS_ErrMsg:'',
            Device_ErrMsg:''
          }
        },
        dialogState:false,
        moteErrorMsg:'',
        columnSize:{
          snap:Number,
          webApp:Number
        }
    }
  },
  watch:{
    async mmsReady(){
        if(this.mmsReady){
          await this.getSnapStatus()
        }
    },
    eventList(){
        let _data=this.getLastItemInArray(this.eventList)
        if(_data.type==='State'){
          if(_data.data.regtoCenter !== undefined){
            this.errorMsg=_data.data.regtoCenter.ErrMsg
          }
          else{
            this.errorMsg=Object.values(_data.data).toString()
            this.isShowErrorMsg=true
          }
        }
        else if(_data.type=== 'Out'){
          this.moteErrorMsg=_data.data[0].IN.State.ErrMsg
          if(this.moteErrorMsg=== 'OK'){
            this.isMoteConnected=true
            if(this.taskNow === this.taskList.find(item=>item.name==='installed').value){
              this.snapInstallList=_data.data[0].Reply.Data
            }
            else if(this.taskNow === this.taskList.find(item=>item.name==='autoStart').value){
              this.appAutoStartList=_data.data[0].Reply.Data.start
            }
            else if(this.taskNow === this.taskList.find(item=>item.name==='checkBrowser').value){
              if(_data.data[0].Reply.Data[0] !==undefined){
                if(Object.keys(_data.data[0].Reply.Data[0])[0]==='chromium-browser')
                  this.isChromium_browser=true
              }
            }
          }
          else{
            this.isMoteConnected=false
          }
        }
        this.dialogData={
          time:this.getTime(),
          data:{
            DeviceUdid:this.moteNow,
            WebMMS_ErrMsg:this.errorMsg,
            Device_ErrMsg:this.moteErrorMsg
          }
        }
    },
    snapInstallList(){
      if(this.snapInstallList !== null){
        if(this,this.snapInstallList.find(item=>item.Name==='chromium')){
          this.isChromium=true
        }
        else{
          this.isChromium=false
        }
        this.snap.forEach((item,index)=>{
          if(this.snapInstallList.find(item2=>item2.Name===item.name)){
            this.snap[index].installed=true
          }
          else{
            this.snap[index].installed=false
          }
        })
      }
    },
    appAutoStartList(){
      if(this.appAutoStartList!==null){
        this.snap.forEach((item,index)=>{
          if(this.appAutoStartList.find(item2=>item2===item.name+'.desktop')){
            this.snap[index].autostart=true
          }
          else{
            this.snap[index].autostart=false
          }
        })
        this.webApp.forEach((item,index)=>{
          if(this.appAutoStartList.find(item2=>item2===item.name+'.desktop')){
            this.webApp[index].autostart=true
          }
          else{
            this.webApp[index].autostart=false
          }
        })
      }
    },
    loading(){
      if(this.dialogData.data.WebMMS_ErrMsg !== '' && this.dialogData.data.Device_ErrMsg !== ''){
        if(this.dialogData.data.WebMMS_ErrMsg !== 'OK' || this.dialogData.data.Device_ErrMsg !== 'OK')
          this.isShowErrorMsg=true
        else
          this.isShowErrorMsg=false
      }
    }
  },
  computed: {},
  directives: {
        'indicator' : {
           bind(el, binding, vnode){
              setInterval(() => {
                if(el.style.backgroundColor == 'gray'){
                    el.style.backgroundColor = '';
                }else{
                    el.style.backgroundColor = 'gray';
                }
             }, 1000);
           }
        }
  },
  async created() {
    this.params = this.$route.query;
    console.log(this.params);
    this.setMoteInfo()
    this.columnSize['snap']=this.getColumnSize(this.snapProperty);
    this.columnSize['webApp']=this.getColumnSize(this.webAppProperty)
    this.startMMS();
  },
  async beforeMount() {
    await this.subscribeMMS();
    this.sortSnapList();
    if(this.params.action=='keyBot')
      this.changeType('keyBot');
  },
  async mounted(){
  },
  beforeDestroy() {
    this.removeEvent();
  },
  methods: {
    async checkBrowser(){
      this.taskNow=this.taskList.find(item=>item.name==='checkBrowser').value
      if(!this.isChromium){
        this.urt={
          ddn:this.moteDDN,
          topic:'mote://apt',
          func:'',
          payload:{
            "operate": "list",
            "type": "apt",
            "keyword": "chromium-browser --installed"
          }
        }
        await this.webmmsSubmit()
      }
      this.taskNow=''
      console.log('Check browser')
    },
    async installChromium(){
      this.urt={
        ddn:this.moteDDN,
        topic:'mote://apt',
        func:'',
        payload:{
          "operate":"install",
          "type":"snap",
          "packageName":"chromium"
        }
      }
      await this.webmmsSubmit()
      //this.reloadPage()
    },
    changeType(type){
      this.typeList.forEach(item=>{
        if(item.type!==type){
          item.isNow=false
        }
        else{
          item.isNow=true
        }
      })
    },
    setMoteInfo(){
      if(this.params.udid!==null &&this.params.udid!==undefined){
        this.moteNow=this.params.udid
        this.moteDDN='>h3/'+this.moteNow+'/main-app'
        this.isNoMoteUdid=false
      }
      else{
        this.isNoMoteUdid=true
      }
    },
    getLastItemInArray(array){
      return array[array.length-1];
    },
    sortSnapList(){
      this.snap.sort((a,b)=>{
      var nameA = a.name.toUpperCase() // ignore upper and lowercase
      var nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;})
    },
    getColumnSize(array){
      return Math.floor(12/array.length);
    },
    reloadPage(){
        this.$router.go();
    },
    goToPage(page){
        this.$router.push(page);
    },
    goToActionPage(app,type){
      if(type === 'snap')
        this.$router.replace({path:'pm/action',query:{udid:this.moteNow,snap:app}})
      else if(type === 'webApp'){
        if(this.isChromium)
          this.$router.replace({path:'pm/action',query:{udid:this.moteNow,webApp:app,browser:'chromium'}})
        else if(this.isChromium_browser)
          this.$router.replace({path:'pm/action',query:{udid:this.moteNow,webApp:app,browser:'chromium-browser'}})
        else
          alert('You do not have install Web Browser.')
      }
    },
    toggle(){
      this.dialogState=true
    },
    resetSanpStatus(){
      this.snapInstallList=null
      this.appAutoStartList=null
    },
    async getSnapStatus(){
      this.resetSanpStatus()
      if(this.moteNow!=='' && this.moteNow !== undefined){
        await this.getInstalledSnapList()
        if(this.moteErrorMsg === 'OK'){
          await this.getAutoStartSnapList()
          await this.checkBrowser()
        }
      }
      else{
        console.log('mote list is empty')
      }
    },
    async getInstalledSnapList(){
      this.taskNow=this.taskList.find(item=>item.name==='installed').value
      this.urt={
        ddn:this.moteDDN,
        topic:'mote://apt',
        func:'',
        payload:{
          "operate": "list",
          "type": "snap"
        }
      }
      await this.webmmsSubmit()
      console.log('Get Installed Snap List')
      this.taskNow=''
    },
    async getAutoStartSnapList(){
      this.taskNow=this.taskList.find(item=>item.name==='autoStart').value
      this.urt={
        ddn:this.moteDDN,
        topic:'mote://schedule',
        func:'',
        payload:{
          "operate": "list",
          "type": "boot"
        }
      }
      await this.webmmsSubmit()
      console.log('Get AutoStart Snap List')
      this.taskNow=''
    },
    checkWebMMSState() {
      if (!this.mmsReady) {
        this.errorMsg = "WebMMS is not connected or registered.";
        this.errorLoading = true;
        return false;
      } else return true;
    },
    setLog(data, type){
        let _data =typeof data == 'object' ? Object.assign({},data) : {data : data};
        if(_data.payload){
          _data.payload = this.isJson(_data.payload) ? JSON.parse(_data.payload) : _data.payload;
        }
        let log = {
            time : this.getTime(),
            data : _data,
            type: type
        };
        this.eventList.push(log);
    },
    async webmmsSubmit(){
        //this.$validator.validateAll();
        const { ddn, topic, func, payload } = this.urt;
        if(func && func != ''){
            this.loading = true;
            let res;
            try {
               res = await this.mms.callMMS({
                  DDN : ddn,
                  topic : topic,
                  func: func,
                  payload: this.isJson(payload) ? JSON.parse(payload) : payload
              });
            } catch (error) {
              this.setLog({'websocket': error}, 'State');
            }
            this.loading = false;
            if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];
                console.log(result);
                if(!result)
                  return;
                this.setLog(result, 'Out');
            }
        }else{
           this.loading = true;
           let res;
           try {
               res = await this.mms.sendMMS({
                  DDN : ddn,
                  topic : topic,
                  payload: this.isJson(payload) ? JSON.parse(payload) : payload
              });
           } catch (error) {
             this.setLog({'websocket': error}, 'State');
           }
            this.loading = false;

            if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];
                console.log(result);
                if(!result)
                  return;
                this.setLog(result, 'Out');
            }
        }

      },
    startMMS() {
      this.mms = webmms({
        wsurl: conf.wsurl,
        EiToken: getCookie("jj-EiToken") || "",
        SToken: getCookie("jj-SToken") || ""
      });
    },
    async subscribeMMS() {
      this.removeEvent = this.mms.on("registered", async reply => {
        //console.log('reply=%s', JSON.stringify(reply))
        this.errorMsg=reply.ErrMsg
        if (reply.ErrMsg == "OK") {
          this.eiInfo.ddn = reply.result.DDN;
          this.webmmsOptions.EiToken = reply.result.EiToken;
          this.webmmsOptions.SToken = reply.result.SToken;
          this.webmmsOptions.UToken = reply.result.UToken;
          if (this.eiInfo.eiName == "") {
            this.eiInfo.eiName = reply.result.EiName
              ? reply.result.EiName
              : "jb" + this.makeId(5);
          }
          if (this.eiInfo.eiTag == "") {
            this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : "";
          }
          this.mmsReady = true;
          this.error = false;
        } else {
          this.mmsReady = false;
          this.error = false;
        }

        setCookie("jj-EiToken", this.webmmsOptions.EiToken);
        setCookie("jj-SToken", this.webmmsOptions.SToken);

        console.log("regtoCenter: %s", reply.ErrMsg);
        this.setLog({'regtoCenter':reply}, 'State');
        let deviceInfo = {
          DDN: this.eiInfo.ddn,
          EiOwner: "",
          EiName: this.eiInfo.eiName,
          EiType: ".page",
          EiTag: this.eiInfo.eiTag,
          EiLoc: ""
        };
        let result = await this.mms.setDeviceInfo(deviceInfo);

        console.log("SetDevice reply=%s", JSON.stringify(result));
      });

      this.mms.on('message', (method, from, data, body) => {
             this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if(typeof data == 'object' && !data.from)
              data.from = from;
            //body.sender = data;
            if(data)
            {

              //this.eventList.push(data.data);
              this.setLog({From : from, Data: data}, 'In');

            }
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.setLog({'WS error':msg}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('disconnect', msg => {
            this.setLog({'disconnect':msg}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('error', err => {
            this.setLog({'error':err}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('connect_error', err => {
            this.setLog({'connect_error':err}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('connect_timeout', err => {
             this.setLog({'connect_timeout':err}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });
      }

  }
}
</script>

<style scoped>
.event_card{
   width: 95vw;
   background-color: rgb(250, 248, 248) ;
}
.urt_form{
    margin-bottom: 0;
}
.event_body{
   /* background-color:#e9fafb; */
}
.event_status{
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 6px;
  vertical-align: middle;
  margin-top: -5px;
}
.event_status_connect{
   background-color:#08b325;
   border-color: #08b325;
}
.event_mote_disconnect{
   background-color: #d22727;
   border-color: #b72626;
}
.event_webmms_disconnect{
  background-color:#F5F500;
  border-color:#F5F500;
}
.event_mote_empty{
  background-color: gray;
  border-color: gray;
}
.theme--light.v-sheet {
    background-color: #fff;
    border-color: #fff;
    color: rgba(0,0,0,.87);
}
.theme--light.v-card {
    background-color: #fff;
    border-color: #fff;
    color: rgba(0,0,0,.87);
}
.loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}
.scroller{
  max-width:100vw;
  height:65vh;
  overflow-y:scroll;
  overflow-x:hidden;
}
.scroller::-webkit-scrollbar{
  display: none;
}
.custom-disable.v-btn--disabled{
  color: rgba(0,0,0,.87) !important;
}
.imformChromium{
  position: absolute;
  width: 100%;
  height: 75%;
  left:0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}
</style>

<style>
.v-list__tile--avatar{
   height: 35px !important;
}
.v-list__tile__sub-title {
    font-size: 10pt;
}
.event_header .v-toolbar__content{
   height: 45px !important;
       display: block;
}
.item_form .v-text-field__details{
  margin: 0 !important;
}
.xs_input .v-input__control{
    min-height: 37px !important;
}
.xs_input .v-input__slot{
    margin-bottom: 3px !important;
}
.xs_input .v-label{
  font-size: 12px !important;
}
</style>
